export const location = {
  rexmonster: [
    {
      text: "Hyderabad / Secunderabad, Telangana",
      id: "72da2468-1cbc-4a9a-863a-89e2cfd6502f",
      extraInfo: {
        countryName: "India",
        countryIsoCode: "IN",
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Bengaluru / Bangalore",
      id: "67bfdcae-92cb-4783-bf40-37f639e57710",
      extraInfo: {
        countryName: "India",
        countryIsoCode: "IN",
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Pune",
      id: "0fb3f865-7da3-424a-8f14-a0d9db705ec1",
      extraInfo: {
        countryName: "India",
        countryIsoCode: "IN",
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Delhi",
      id: "b555ca75-7697-462f-a57d-64b42fb98b49",
      extraInfo: {
        countryName: "India",
        countryIsoCode: "IN",
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Chennai",
      id: "b2b9a668-5339-4ea8-8b02-2f7e1a582556",
      extraInfo: {
        countryName: "India",
        countryIsoCode: "IN",
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
  ],
  monstergulf: [
    {
      text: "Dubai",
      id: "d59226bb-f506-43bb-9346-431082d83c86",
      extraInfo: {
        countryUuId: "324e7e86-ee0d-4c0d-a1bd-7f0d24bcd6b3",
        countryIsoCode: "AE",
        countryName: "United Arab Emirates",
      },
    },
    {
      text: "Egypt",
      id: "7213d2c4-dd44-40e2-aa4e-52dd1fd19609",
      extraInfo: {
        countryUuId: "8e6b50a6-ca7d-443c-8ff4-cc5123a474f3",
        countryIsoCode: "EG",
        countryName: "Egypt",
      },
    },
    {
      text: "Cairo",
      id: "965fd70b-d6df-41e4-a081-c8ecb8c7ce5b",
      extraInfo: {
        countryUuId: "8e6b50a6-ca7d-443c-8ff4-cc5123a474f3",
        countryIsoCode: "EG",
        countryName: "Egypt",
      },
    },
    {
      text: "Qatar",
      id: "532c9090-4070-4b33-9d8e-2b40d4206890",
      extraInfo: {
        countryUuId: "ce66d57b-f5bd-44c3-b725-9f4f829ec437",
        countryIsoCode: "QA",
        countryName: "Qatar",
      },
    },
    {
      text: "Abu Dhabi",
      id: "d84dad3e-3554-439b-bffb-b874126c2d83",
      extraInfo: {
        countryUuId: "324e7e86-ee0d-4c0d-a1bd-7f0d24bcd6b3",
        countryIsoCode: "AE",
        countryName: "United Arab Emirates",
      },
    },
  ],
  monstersingapore: [
    {
      text: "Singapore",
      id: "c65af7b5-5fda-42e0-984d-4fa38e8284b1",
      extraInfo: {
        countryName: "Singapore",
        countryUuId: "d0fbac9b-a9bb-47de-ace2-72dadcc086f4",
        countryIsoCode: "SG",
      },
    },
    {
      text: "India",
      id: "fc71fff2-b98a-4cd8-a482-2e197cb4fc34",
      extraInfo: {
        countryName: "India",
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
        countryIsoCode: "IN",
      },
    },
    {
      text: "SriLanka",
      id: "ed0b5261-4636-11e9-a89e-70106fbef856",
      extraInfo: {
        countryUuId: "3fd2e744-5112-40de-9321-b8ddf0850131",
        countryIsoCode: "LK",
        countryName: "SriLanka",
      },
    },
    {
      text: "Myanmar/Burma",
      id: "2decd8dd-5279-11ec-96c9-0022486e8c2d",
      extraInfo: {
        countryUuId: "046a68ae-b78e-4f82-b6f9-88e1970da1a4",
        countryIsoCode: "MM",
        countryName: "Myanmar",
      },
    },
    {
      text: "Philippines",
      id: "9ffe9456-654e-4fb9-9b8c-5b0994904264",
      extraInfo: {
        countryUuId: "1e8c041e-f263-42f6-a941-fa41ac61ee8d",
        countryIsoCode: "PH",
        countryName: "Philippines",
      },
    },
    {
      text: "Malaysia",
      id: "3a47de7e-14ab-46df-bb02-4230ecb7cca3",
      extraInfo: {
        countryUuId: "9917b387-7365-4167-8044-75c3ee8a919d",
        countryIsoCode: "MY",
        countryName: "Malaysia",
      },
    },
  ],
  monsterthailand: [
    {
      text: "Phuket",
      id: "e730fa5d-8c59-436c-9ddd-17e847bae159",
      extraInfo: {
        countryUuId: "e07a6422-a4cf-4c66-b701-cd023d5fafbc",
        countryIsoCode: "TH",
        countryName: "Thailand",
      },
    },
    {
      text: "Bangkok Area",
      id: "21a6c505-a945-4be6-946f-6f640fcbcdf3",
      extraInfo: {
        countryUuId: "e07a6422-a4cf-4c66-b701-cd023d5fafbc",
        countryIsoCode: "TH",
        countryName: "Thailand",
      },
    },
    {
      text: "Sa Kaeo",
      id: "78b2c329-463f-463d-a789-27953235ff62",
      extraInfo: {
        countryUuId: "e07a6422-a4cf-4c66-b701-cd023d5fafbc",
        countryIsoCode: "TH",
        countryName: "Thailand",
      },
    },
    {
      text: "Thailand",
      id: "1aee52d9-5e7e-4d40-8f1e-8ec1ec6b121f",
      extraInfo: {
        countryUuId: "e07a6422-a4cf-4c66-b701-cd023d5fafbc",
        countryIsoCode: "TH",
        countryName: "Thailand",
      },
    },
    {
      text: "Rayong",
      id: "18c9456d-6fff-4a0a-91bd-a818a8a3faf8",
      extraInfo: {
        countryUuId: "e07a6422-a4cf-4c66-b701-cd023d5fafbc",
        countryIsoCode: "TH",
        countryName: "Thailand",
      },
    },
  ],
  monsterphilippines: [
    {
      text: "Philippines",
      id: "9ffe9456-654e-4fb9-9b8c-5b0994904264",
      extraInfo: {
        countryUuId: "1e8c041e-f263-42f6-a941-fa41ac61ee8d",
        countryIsoCode: "PH",
        countryName: "Philippines",
      },
    },
    {
      text: "Metro Manila / NCR",
      id: "af98b9c3-d7a0-435d-bcd9-06b8fee0a0be",
      extraInfo: {
        countryUuId: "1e8c041e-f263-42f6-a941-fa41ac61ee8d",
        countryIsoCode: "PH",
        countryName: "Philippines",
      },
    },
    {
      text: "Cebu City",
      id: "42411de7-d419-4840-b01e-797334f44bce",
      extraInfo: {
        countryUuId: "1e8c041e-f263-42f6-a941-fa41ac61ee8d",
        countryIsoCode: "PH",
        countryName: "Philippines",
      },
    },
    {
      text: "Quezon City",
      id: "0de1c598-f251-4130-932c-430534c6f808",
      extraInfo: {
        countryUuId: "1e8c041e-f263-42f6-a941-fa41ac61ee8d",
        countryIsoCode: "PH",
        countryName: "Philippines",
      },
    },
    {
      text: "Davao",
      id: "5e171270-d8a4-45bb-b194-544b15a57358",
      extraInfo: {
        countryUuId: "1e8c041e-f263-42f6-a941-fa41ac61ee8d",
        countryIsoCode: "PH",
        countryName: "Philippines",
      },
    },
  ],
  monstervietnam: [
    {
      text: "Ho Chi Minh",
      id: "76362b15-3b35-11e9-a89e-70106fbef856",
      extraInfo: {
        countryUuId: "efe150f3-eaeb-419f-9b02-4b85b73a26df",
        countryIsoCode: "VN",
        countryName: "Vietnam",
      },
    },
    {
      text: "Vietnam",
      id: "33f7ee59-3b35-11e9-a89e-70106fbef856",
      extraInfo: {
        countryUuId: "efe150f3-eaeb-419f-9b02-4b85b73a26df",
        countryIsoCode: "VN",
        countryName: "Vietnam",
      },
    },
    {
      text: "Hanoi",
      id: "d4b99e6c-cc85-4ede-b358-8cdd749af22c",
      extraInfo: {
        countryUuId: "efe150f3-eaeb-419f-9b02-4b85b73a26df",
        countryIsoCode: "VN",
        countryName: "Vietnam",
      },
    },
    {
      text: "Da Nang",
      id: "7633c791-3b35-11e9-a89e-70106fbef856",
      extraInfo: {
        countryUuId: "efe150f3-eaeb-419f-9b02-4b85b73a26df",
        countryIsoCode: "VN",
        countryName: "Vietnam",
      },
    },
    {
      text: "Bac Can",
      id: "7630cf07-3b35-11e9-a89e-70106fbef856",
      extraInfo: {
        countryUuId: "efe150f3-eaeb-419f-9b02-4b85b73a26df",
        countryIsoCode: "VN",
        countryName: "Vietnam",
      },
    },
  ],
  monstermalaysia: [
    {
      text: "Malaysia",
      id: "3a47de7e-14ab-46df-bb02-4230ecb7cca3",
      extraInfo: {
        countryUuId: "9917b387-7365-4167-8044-75c3ee8a919d",
        countryIsoCode: "MY",
        countryName: "Malaysia",
      },
    },
    {
      text: "Kuala Lumpur",
      id: "40f5f05f-06e0-482c-8f06-bc53a79bcb13",
      extraInfo: {
        countryUuId: "9917b387-7365-4167-8044-75c3ee8a919d",
        countryIsoCode: "MY",
        countryName: "Malaysia",
      },
    },
    {
      text: "Selangor",
      id: "ad1b8e2e-54de-41b7-be32-4634947c01e4",
      extraInfo: {
        countryUuId: "9917b387-7365-4167-8044-75c3ee8a919d",
        countryIsoCode: "MY",
        countryName: "Malaysia",
      },
    },
    {
      text: "Johor Bahru",
      id: "d40c6d93-5827-43ce-83da-267f519a5fe3",
      extraInfo: {
        countryUuId: "9917b387-7365-4167-8044-75c3ee8a919d",
        countryIsoCode: "MY",
        countryName: "Malaysia",
      },
    },
    {
      text: "Penang",
      id: "4e3d97fa-82fd-4453-b216-b742759ccb41",
      extraInfo: {
        countryUuId: "9917b387-7365-4167-8044-75c3ee8a919d",
        countryIsoCode: "MY",
        countryName: "Malaysia",
      },
    },
  ],
  monsterindonesia: [
    {
      text: "Indonesia",
      id: "67a662a1-b4e8-44aa-ac70-22e653afc1bb",
      extraInfo: {
        countryUuId: "17c96887-4203-4d4a-a771-2b213d0dc955",
        countryIsoCode: "ID",
        countryName: "Indonesia",
      },
    },
    {
      text: "jakarta Raya",
      id: "8413b3f7-12a1-4ffc-8258-c574a964d85f",
      extraInfo: {
        countryUuId: "17c96887-4203-4d4a-a771-2b213d0dc955",
        countryIsoCode: "ID",
        countryName: "Indonesia",
      },
    },
    {
      text: "Bali",
      id: "40819ce5-0384-4e68-9276-77b6b6f2c80b",
      extraInfo: {
        countryUuId: "17c96887-4203-4d4a-a771-2b213d0dc955",
        countryIsoCode: "ID",
        countryName: "Indonesia",
      },
    },
    {
      text: "Bandung",
      id: "ccf57a13-0e2b-4f11-beaa-8fc5675669ef",
      extraInfo: {
        countryUuId: "17c96887-4203-4d4a-a771-2b213d0dc955",
        countryIsoCode: "ID",
        countryName: "Indonesia",
      },
    },
    {
      text: "Surabaya",
      id: "9042bbf0-769e-41e8-a6c2-f9f8ab722d7d",
      extraInfo: {
        countryUuId: "17c96887-4203-4d4a-a771-2b213d0dc955",
        countryIsoCode: "ID",
        countryName: "Indonesia",
      },
    },
  ],
  monsterhongkong: [
    {
      text: "Hong Kong",
      id: "75c8409f-3b36-11e9-a89e-70106fbef856",
      extraInfo: {
        countryUuId: "aa3cc3b5-59b1-4673-a8ce-c410b8505348",
        countryIsoCode: "HK",
        countryName: "Hong Kong",
      },
    },
    {
      text: "China",
      id: "d8684458-3b14-42d7-9180-f95ee285d3d1",
      extraInfo: {
        countryUuId: "aa3cc3b5-59b1-4673-a8ce-c410b8505348",
        countryIsoCode: "HK",
        countryName: "Hong Kong",
      },
    },
    {
      text: "Shanghai",
      id: "edcb3451-34ad-43f8-8ae5-8f1416f19b3d",
      extraInfo: {
        countryUuId: "ef256401-22fd-43d1-90a7-d38d2ef1e908",
        countryIsoCode: "CN",
        countryName: "China",
      },
    },
    {
      text: "Beijing",
      id: "1cf1db90-331f-427a-a302-242baa9b8822",
      extraInfo: {
        countryUuId: "ef256401-22fd-43d1-90a7-d38d2ef1e908",
        countryIsoCode: "CN",
        countryName: "China",
      },
    },
    {
      text: "Taiwan",
      id: "4bd5aef3-0013-4754-966d-e069a7d9e6f2",
      extraInfo: {
        countryUuId: " e5966b40-6f97-41b7-b7a7-51f8c5ddea0d",
        countryIsoCode: "TW",
        countryName: "Taiwan",
      },
    },
  ],
};
